var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"team-wrapper"}},[_vm._v("our.story.wrapper")])
}
var staticRenderFns = []

export { render, staticRenderFns }